import React from "react";
import Typewriter from "typewriter-effect";

export default function HomePage() {
  return (
    <section id="home">
      <div className="flex justify-center h-screen text-center flex-col min-w-[320px]">
        <div className="flex justify-center items-center w-full">
          <div className="min-w-[320px]">
            <h2 className="text-base font-semibold uppercase font-sans text-left text-pryClr text-opacity-50">
              hello i am
            </h2>

            <h1 className="text-[125px] md:text-[15vw] text-[#DFDFDF] uppercase font-sanss font-bold min-w-[300px]">
              Josh
            </h1>

            <div className="text-pryClr text-opacity-40 text-xl">
              <Typewriter
                Typewriter__wrapper
                onInit={(typewriter) => {
                  typewriter
                    .pauseFor(2500)
                    .typeString(
                      "A <strong style='color: #DFDFDF;'>Front-End</strong> Developer."
                    )
                    .pauseFor(300)
                    .deleteChars(24)
                    .typeString(
                      'I write <strong><span style="color: #DFDFDF;">ReactJs,</strong> <strong><span style="color: #D1C56C;">NextJs,</strong> <strong><span style="color: #f34c08;">Typescript.</strong>'
                    )
                    .pauseFor(1000)
                    .start();
                }}
                options={{ autoStart: true, loop: true, delay: 75 }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
